export const fetchMultistageOlympiadWidgetList = async () => {
  const response = await fetch(
    'https://uchi.ru/api/configurator/public?configs=cabmun_multistage_olympiad_widget_list',
  );
  const data = await response.json();
  return data?.cabmun_multistage_olympiad_widget_list;
};
